import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../../services/auth.service';
import { Subscription, interval } from 'rxjs';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-login',
  templateUrl: './logoutTimer.component.html',
  styleUrls: ['./logoutTimer.component.scss']
})

export class LogoutTimerComponent implements OnInit {
  public timeDifference = 900;
  private subscription: Subscription;
  constructor(private authService: AuthService, public dialogRef: MatDialogRef<LogoutTimerComponent>) { }

  ngOnInit() {
    this.subscription = interval(1000)
           .subscribe(x => { this.getTimeDifference(); });
  }

  getTimeDifference(){
    const ud = localStorage.getItem('auth');
      if (ud != null){
        const ud_json = JSON.parse(ud);
        this.timeDifference = Math.trunc((ud_json.expr - new  Date().getTime()));
      }
  }

  logout() {
    this.authService.logout();
    this.dialogRef.close();
  }

  extendSession(){
    this.authService.refreshToken();
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }
}
